
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"completedWalkable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompletedWalkable"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elementId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elementType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elementAttemptId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenarioCorrectness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"triggeredActions"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":204}};
    doc.loc.source = {"body":"fragment completedWalkable on CompletedWalkable {\n  evaluationId\n  evaluatedAt\n  elementId\n  elementType\n  elementAttemptId\n  evaluation {\n    scenarioCorrectness\n    completed\n    triggeredActions\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
